import script from "./WorkspaceConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceConfiguration.vue?vue&type=style&index=0&id=434ba734&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434ba734"]])

export default __exports__